import { useContext, useContextSelector } from 'use-context-selector';
import { TutorialContext } from '../tutorial-provider';
export default function useTutorial() {
  return useContext(TutorialContext);
}
export function useTutorialNext() {
  return useContextSelector(TutorialContext, context => context.next);
}